import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/games/new')({
  component: NewGamePage,
});

function NewGamePage() {
  const navigate = useNavigate();

  // Redirect to games list - form is now in a sheet
  useEffect(() => {
    navigate({ to: '/games', replace: true }).catch(() => {
      // Ignore navigation errors
    });
  }, [navigate]);

  return undefined;
}
